import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import { unAuthorized } from "../../../../auth/Auth.ducks";
import { Service } from "../../../../service/service";
import _ from "lodash";

export const FETCH_TEAM_PENDING = "FETCH_TEAM_PENDING";
export const FETCH_TEAM_REJECTED = "FETCH_TEAM_REJECTED";
export const FETCH_TEAM_FULFILLED = "FETCH_TEAM_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case FETCH_TEAM_PENDING:
      return true;
    case FETCH_TEAM_REJECTED:
    case FETCH_TEAM_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, payload }) => {
  switch (type) {
    case FETCH_TEAM_PENDING:
    case FETCH_TEAM_FULFILLED:
      return null;
    case FETCH_TEAM_REJECTED:
      return payload;
    default:
      return state;
  }
};

const team = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_TEAM_FULFILLED:
      return payload.data;

    default:
      return state;
  }
};

export default combineReducers({ loading, error, team });

export const fetchTeam = (tok) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/creche/agents`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: FETCH_TEAM_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: FETCH_TEAM_REJECTED, payload: err });
      if (err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
